document.addEventListener("DOMContentLoaded", () => {
  const menus = document.querySelectorAll('.paragraph--type--menu');

  menus.forEach((menu) => {
    const tabs = menu.querySelectorAll(".tab-link");
    const contents = menu.querySelectorAll(".tab-panel");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        // Remove active class from all tabs and content
        tabs.forEach((t) => t.classList.remove("active"));
        contents.forEach((c) => c.classList.remove("active"));
  
        // Add active class to clicked tab and corresponding content
        tab.classList.add("active");
        menu.querySelector('#' + tab.dataset.target).classList.add('active');
        // menu.getElementById(tab.dataset.target).classList.add("active");
      });
    });
  });
});
